import React from 'react';
import AccordionSection from '../common/AccordionSection';

export default function LMRAChecklist({ permit, checklist, onUpdate, isReadOnly, isOpen = true, onToggle, previewMode = false }) {

    // LMRA Questions
    const lmraQuestions = [
        { id: 'q1', text: 'Is de werkplek veilig en vrij van obstakels?' },
        { id: 'q2', text: 'Heb ik de juiste vergunningen en PBM\'s?' },
        { id: 'q3', text: 'Begrijp ik de taak volledig?' },
        { id: 'q4', text: 'Voel ik mij fit en bekwaam voor deze taak?' }
    ];

    if (permit.qualification && permit.qualification !== 'Geen') {
        lmraQuestions.push({
            id: 'q_qual',
            text: `Ben ik bevoegd als ${permit.qualification} voor deze taak?`
        });
    }

    const handleCheck = (qId, isChecked) => {
        const newChecklist = { ...checklist, [`lmra_${qId}`]: isChecked };

        // Check if all are true to unlock
        const allTrue = lmraQuestions.every(question =>
            question.id === qId ? isChecked : newChecklist[`lmra_${question.id}`]
        );

        // Update Lock State automatically
        newChecklist.lmraLocked = !allTrue;

        // Perform update
        onUpdate(newChecklist);
    };

    const allChecked = checklist.lmraLocked === false;

    return (
        <AccordionSection
            title="LMRA: Start Werk Check"
            icon="🔴"
            isOpen={isOpen}
            isComplete={allChecked}
            onClick={onToggle}
        >
            <div className="space-y-2 mt-4">
                {lmraQuestions.map((q) => {
                    const isChecked = checklist[`lmra_${q.id}`];
                    return (
                        <label
                            key={q.id}
                            className={`flex items-start gap-4 cursor-pointer p-4 md:p-5 rounded-xl border-2 transition-all shadow-lg ${isChecked
                                ? 'bg-green-500/10 border-green-500/30'
                                : 'bg-slate-800/50 border-slate-700 hover:border-slate-600 hover:bg-slate-800'
                                }`}
                        >
                            <input
                                type="checkbox"
                                className="w-6 h-6 rounded border-slate-500 text-green-600 bg-slate-900 mt-1 cursor-pointer shrink-0"
                                checked={!!isChecked}
                                disabled={isReadOnly}
                                onChange={(e) => !isReadOnly && handleCheck(q.id, e.target.checked)}
                            />
                            <span className={`text-sm leading-snug flex-1 font-bold ${isChecked ? 'text-green-400' : 'text-slate-200'}`}>
                                {q.text}
                            </span>
                        </label>
                    )
                })}
            </div>
            {allChecked && (
                <div className="mt-4 p-3 bg-green-500/10 border border-green-500/30 rounded-lg text-green-400 text-sm font-bold flex items-center gap-2">
                    <span>✓ LMRA voltooid. De volgende secties zijn nu ontgrendeld.</span>
                </div>
            )}
        </AccordionSection>
    );
}
